import PortalIdParser from 'PortalIdParser';
import { isMultiBrandEnabled } from 'documents-lib/js/utils/isMultiBrandEnabled';
const SELECTED_BUSINESS_UNIT = 'SELECTED_BUSINESS_UNIT';
export const getSelectedBrandId = () => {
  const portalId = PortalIdParser.get();
  if (!isMultiBrandEnabled() || portalId === undefined) {
    return undefined;
  }
  try {
    var _localStorage$getItem;
    const parsed = JSON.parse((_localStorage$getItem = localStorage.getItem(SELECTED_BUSINESS_UNIT)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '{}');
    const brandId = parsed[portalId];
    return typeof brandId === 'number' ? brandId : undefined;
  } catch (_unused) {
    return undefined;
  }
};